<script setup>
import { RouterView, RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '@/mini/stores/auth'

const authStore = useAuthStore()
const router = useRouter()

function handleLogout() {
  authStore.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <header v-if="authStore.isAuthenticated" class="app-header">
    <strong>JOPCO</strong>
    <nav>
      <RouterLink :to="{ name: 'home' }">Collection</RouterLink>
      <button type="button" @click="handleLogout">Log out</button>
    </nav>
  </header>
  <RouterView />
</template>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}
.app-header nav {
  display: flex;
  gap: 1rem;
  align-items: center;
}
</style>
